var processInclude = require("base/util");

if ($("#cbt-site-location").length) {
    processInclude(require("cbt/components/cbtCheckoutLogin"));
}

$(document).ready(function () {
    processInclude(require("./login/login"));
    processInclude(require("./checkout/checkoutFooter"));
});
